export const DonationTabs = {
    alms_donors: "alms_donors",
    founding_donors: "founding_donors",
    padetha_donors: "padetha_donors",
}

export type DonationTabsType = keyof typeof DonationTabs;